import React, { useRef } from 'react';
import { useTrackingActions } from '../context/TrackingContext/TrackingContext';
import { useOnComponentVisible } from '../hooks/useOnComponentVisible';
import Card from '../components/Card/Card';
import type { Props as CardProps } from '../components/Card/types';

export const SectionCardView: React.FC<CardProps> = ({
  title,
  body,
  showReadMore,
  onReadMoreClick,
  size,
  bodyClassName,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { onSectionVisible } = useTrackingActions();

  useOnComponentVisible({
    ref,
    onBecomingVisible: () => {
      onSectionVisible(title);
    },
  });

  // The ref lives on the card itself: a separate sentinel element would be an
  // extra flex item in the gapped row and push the first card out of alignment.
  return (
    <Card
      ref={ref}
      title={title}
      body={body}
      onReadMoreClick={onReadMoreClick}
      showReadMore={showReadMore}
      size={size}
      bodyClassName={bodyClassName}
    />
  );
};
